import { render, staticRenderFns } from "./app-detail-download-recommend-drawer.vue?vue&type=template&id=59cf316e&scoped=true&"
import script from "./app-detail-download-recommend-drawer.vue?vue&type=script&lang=js&"
export * from "./app-detail-download-recommend-drawer.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download-recommend-drawer.vue?vue&type=style&index=0&id=59cf316e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf316e",
  null
  
)

export default component.exports